import { Cycle, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { cycleClient } from './CycleClient';

const factory = createStudyEntityHookFactory<Cycle>(StudyEntityType.Cycle);

export const useCycles = factory.list(cycleClient.list);
